import { MutationsCreator } from '@/store/utils';
import { showErrorToast } from '~/utils/toast-notifications';
import { PROFILE_FEED_TAB_KEYS } from '~/utils/profile-feed-tab-keys';

export default {
  // Profile
  INIT_PROFILE: (state) => {
    state.profile = null;
    state.contentStep = 0;
    state.profileLoading = false;
    state.profileError = null;
    state.contentStep = 0;
    state.followers = [];
    state.followersError = null;
    state.followersLoading = false;
    state.followersPage = 1;
    state.nextFollowersLoading = false;
    state.followed = [];
    state.newsSuscribedLanguages = [];
    state.followedError = null;
    state.followedLoading = false;
    state.followedPage = 1;
    state.nextFollowedLoading = false;
    state.hasSeenWTPModal = false;
  },
  SET_PROFILE: (state, payload) => {
    state.profile = payload;
  },
  SET_PROFILE_FOLLOW: (state, payload) => {
    if (!state.profile || state.profile.profileId !== payload.profileId) {
      return;
    }
    state.profile.isFollowed = payload.isFollowed;
  },
  SET_CONTENT_STEP: (state, step) => {
    state.contentStep = step;
  },
  SET_WTPMODAL_SEEN: (state) => {
    state.hasSeenWTPModal = true;
    state.profile.hasSeenWTPModal = true;
  },
  // Unused, we set the whole profile instead
  TOGGLE_PROFILE_FOLLOW: (state, payload) => {
    state.profile.isFollowed = payload.isFollowed;
  },
  SET_PROFILE_LOADING: (state, isLoading) => {
    state.profileLoading = isLoading;
  },
  TOGGLE_PROFILE_EDIT_MODAL: (state) => {
    state.showProfileEditModal = !state.showProfileEditModal;
  },
  SET_PROFILE_ERROR: (state, error) => {
    state.profileError = error;
    showErrorToast(window.$nuxt.$t('error_loading_profile'));
  },
  SET_PROFILE_CARD_ERROR: (state, error) => {
    state.profileCardError = error;
    showErrorToast(window.$nuxt.$t('error_loading_profile_card'));
  },
  // Profile Feed
  INIT_FEED: (state) => {
    state.feed = [];
    state.feedLoading = false;
    state.feedError = null;
  },
  SET_FEED: (state, payload) => {
    state.feed = payload;
  },
  RESET_PROFILE_FEED: (state) => {
    state.feed = null;
  },
  INIT_POST_FEED: (state) => {
    state.postFeed = [];
    state.postFeedLoading = false;
    state.postFeedError = null;
  },
  SET_POST_FEED: (state, payload) => {
    state.postFeed = payload;
  },
  RESET_PROFILE_POST_FEED: (state) => {
    state.postFeed = null;
  },
  INIT_REPLIES_FEED: (state) => {
    state.repliesFeed = [];
    state.repliesFeedLoading = false;
    state.repliesFeedError = null;
  },
  SET_REPLIES_FEED: (state, payload) => {
    state.repliesFeed = payload;
  },
  RESET_PROFILE_REPLIES_FEED: (state) => {
    state.repliesFeed = null;
  },
  SET_LAST_FETCHED_PROFILE_ID(state, profileId) {
    state.lastFetchedProfileId = profileId;
  },
  SET_FEED_LOADING: (state, isLoading) => {
    state.feedLoading = isLoading;
  },
  SET_POST_FEED_LOADING: (state, isLoading) => {
    state.postFeedLoading = isLoading;
  },
  SET_REPLIES_FEED_LOADING: (state, isLoading) => {
    state.repliesFeedLoading = isLoading;
  },
  SET_NEXT_POST_LOADING: (state, isLoading) => {
    state.nextPostLoading = isLoading;
  },
  SET_NEXT_POST_FEED_LOADING: (state, isLoading) => {
    state.nextPostFeedLoading = isLoading;
  },
  SET_NEXT_REPLIES_FEED_LOADING: (state, isLoading) => {
    state.nextRepliesFeedLoading = isLoading;
  },
  SET_FEED_ERROR: (state, error) => {
    state.postError = error;
    showErrorToast(window.$nuxt.$t('error_loading_profile_feed'));
  },
  SET_POST_FEED_ERROR: (state, error) => {
    state.postFeedError = error;
    showErrorToast(window.$nuxt.$t('error_loading_profile_feed'));
  },
  SET_REPLIES_FEED_ERROR: (state, error) => {
    state.repliesFeedError = error;
    showErrorToast(window.$nuxt.$t('error_loading_profile_feed'));
  },
  INCREMENT_REPLYCOUNT: (state, postId) => {
    let feed;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feed = state.postFeed;
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feed = state.repliesFeed;
    } else {
      feed = state.feed;
    }

    if (!feed) return;

    const index = feed.findIndex((e) => e.postId === postId);
    if (index !== -1) {
      feed[index].replyCount++;
    }
  },

  INCREMENT_REPOSTCOUNT: (state, postId) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const index = feed.findIndex((e) => e.postId === postId);
    if (index !== -1) {
      feed[index].repostCount++;
    }
  },
  APPEND_POSTS_TO_FEED: (state, payload) => {
    state.feed = [...state.feed, ...payload];
  },
  APPEND_FEED_POSTS_TO_FEED: (state, payload) => {
    state.postFeed = [...state.postFeed, ...payload];
  },
  APPEND_FEED_REPLIES_TO_FEED: (state, payload) => {
    state.repliesFeed = [...state.repliesFeed, ...payload];
  },
  APPEND_NEW_POST_AT_TOP: (state, post) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    state[feedKey] = [post, ...state[feedKey]];
  },

  UPDATE_POST: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const index = feed.findIndex((e) => e.postId === payload.postId);
    if (index === -1) return;

    const res = [...feed];
    const post = feed[index];
    if (post.replyCount) payload.replyCount = post.replyCount;
    if (post.replies) payload.replies = post.replies;
    res[index] = payload;

    state[feedKey] = res;
  },
  DELETE_USER_POST_SUCCESS: (state, postId) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const postIndex = feed.findIndex((e) => e.postId === postId);

    if (postIndex !== -1) {
      feed.splice(postIndex, 1);
    }
  },
  DELETE_USER_POST_ERROR: (state, error) => {
    state.deleteUserPost.error = error;
  },
  DELETE_POST_REPLY_SUCCESS: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const postIndex = feed.findIndex((p) => p.postId === payload.postId);

    if (postIndex === -1) return;

    const post = feed[postIndex];
    if (!post.replies) return;

    const replyIndex = post.replies.findIndex(
      (r) => r.postId === payload.replyId
    );
    if (replyIndex === -1) return;

    // Decrementing reply count for the post
    post.replyCount--;
    post.replies.splice(replyIndex, 1);
  },
  DELETE_POST_REPLY_ERROR: (state, error) => {
    state.deleteUserPost.error = error;
  },
  DELETE_POST_NESTED_REPLY_SUCCESS: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((p) => p.postId === payload.postId);
    if (!post || !post.replies) return;

    const reply = post.replies.find((r) => r.postId === payload.replyId);
    if (!reply || !reply.replies) return;

    const nestedReplyIndex = reply.replies.findIndex(
      (nr) => nr.postId === payload.nestedReplyId
    );
    if (nestedReplyIndex === -1) return;

    // Decrementing reply count for the post
    reply.replyCount--;
    reply.replies.splice(nestedReplyIndex, 1);
  },
  SET_ACTIVE_FEED_TAB: (state, payload) => {
    state.activeFeedTab = payload;
  },
  // Profile Followers
  SET_FOLLOWERS: (state, followers) => {
    state.followers = followers;
  },
  APPEND_FOLLOWERS: (state, followers) => {
    state.followers = [...state.followers, ...followers];
  },
  SET_FOLLOWERS_LOADING: (state, isLoading) => {
    state.followersLoading = isLoading;
  },
  SET_NEXT_FOLLOWERS_LOADING: (state, isLoading) => {
    state.nextFollowersLoading = isLoading;
  },
  RESET_FOLLOWERS_PAGE: (state) => {
    state.followersPage = 1;
  },
  INCREASE_FOLLOWERS_PAGE: (state) => {
    state.followersPage++;
  },
  UPDATE_FOLLOWER_IS_FOLLOWED: (state, follower) => {
    if (state.followers) {
      const index = state.followers.findIndex(
        (f) => f.profileId === follower.profileId
      );

      if (index != -1) {
        state.followers[index].isFollowed = follower.isFollowed;
      }
    }
  },
  SET_SHOW_LOAD_MORE_FOLLOWERS: (state, show) => {
    state.showLoadMoreFollowers = show;
  },
  // Profile Followed
  SET_FOLLOWED: (state, followed) => {
    state.followed = followed;
  },
  APPEND_FOLLOWED: (state, followed) => {
    state.followed = [...state.followed, ...followed];
  },
  SET_FOLLOWED_LOADING: (state, isLoading) => {
    state.followedLoading = isLoading;
  },
  SET_NEXT_FOLLOWED_LOADING: (state, isLoading) => {
    state.nextFollowedLoading = isLoading;
  },
  RESET_FOLLOWED_PAGE: (state) => {
    state.followedPage = 1;
  },
  INCREASE_FOLLOWED_PAGE: (state) => {
    state.followedPage++;
  },
  UPDATE_FOLLOWED_IS_FOLLOWED: (state, followed) => {
    if (state.followed) {
      const index = state.followed.findIndex(
        (f) => f.profileId === followed.profileId
      );

      if (index != -1) {
        state.followed[index].isFollowed = followed.isFollowed;
      }
    }
  },
  SET_SHOW_LOAD_MORE_FOLLOWED: (state, show) => {
    state.showLoadMoreFollowed = show;
  },
  SET_AVERAGE_RATING: (state, rating) => {
    state.profile.averageRating = rating;
  },
  SET_RATING_COUNT: (state, count) => {
    state.profile.ratingCount = count;
  },
  SET_FOLLOWED_PROFILES_COUNT_LOADING: (state, value) => {
    state.followedCountPerType.loading = value;
  },
  SET_FOLLOWED_PROFILES_COUNT: (state, value) => {
    state.followedCountPerType.data = value;
  },
  SET_FOLLOWED_PROFILES_COUNT_ERROR: (state, error) => {
    state.followedCountPerType.error = error;
  },
  /// Post Replies
  SET_REPLIES_LOADING: (state, payload) => {
    const post = state.feed.find((e) => e.postId === payload.target);
    if (post) {
      post.repliesLoading = payload.isLoading;
    }
  },
  SET_REPLIES_ERROR: (state, payload) => {
    const post = state.feed.find((e) => e.postId === payload.target);
    if (post) {
      post.repliesError = payload.err;
      //TODO : add some toast
    }
  },
  APPEND_NEW_REPLY: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.target);
    if (!post) return;

    if (!post.replies) {
      post.replies = [];
    }

    const newArray = post.replies.slice(0, 1);
    post.replies = [payload, ...newArray];
    post.replyCount++;
  },
  UPDATE_REPLY: (state, data) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === data.target);
    if (!post || !post.replies) return;

    const index = post.replies.findIndex((e) => e.postId === data.postId);
    if (index === -1) return;

    const res = [...post.replies];
    res[index] = data;
    post.replies = res;
  },
  UPDATE_REPLY_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.feed) return;

    const post = state.feed.find((p) => p.postId === payload.postId);

    if (!post) return;

    const replyToUpdate = post.replies.find(
      (r) => r.postId === payload.replyId
    );

    if (!replyToUpdate) return;

    const newLikedState = !payload.isLiked;

    replyToUpdate.isLiked = newLikedState;
    replyToUpdate.likeCount = newLikedState
      ? (replyToUpdate.likeCount += 1)
      : (replyToUpdate.likeCount -= 1);
  },
  ROLLBACK_REPLY_LIKE: (state, payload) => {
    if (!state.feed) return;

    const post = state.feed.find((p) => p.postId === payload.postId);

    if (!post) return;

    const replyToUpdate = post.replies.find(
      (r) => r.postId === payload.replyId
    );

    if (!replyToUpdate) return;

    replyToUpdate.isLiked = payload.isLiked;
    replyToUpdate.likeCount = payload.likeCount;
  },
  UPDATE_REPLY_AFTER_EDIT: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.postId);

    if (post && post.replies) {
      const replyIndex = post.replies.findIndex(
        (r) => r.postId === payload.data.target
      );
      if (replyIndex !== -1) {
        if (post.replies[replyIndex].replyCount)
          payload.data.replyCount = post.replies[replyIndex].replyCount;
        if (post.replies[replyIndex].replies)
          payload.data.replies = post.replies[replyIndex].replies;

        post.replies.splice(replyIndex, 1, payload.data);
        return;
      }
    }

    const parentPost = feed.find((p) =>
      p.replies?.some((r) => r.postId === payload.postId)
    );
    if (!parentPost) return;

    const parentPostIndex = feed.findIndex((p) =>
      p.replies?.some((r) => r.postId === payload.postId)
    );
    const reply = parentPost.replies.find((r) => r.postId === payload.postId);
    if (!reply || !reply.replies) return;

    const nestedReplyIndex = reply.replies.findIndex(
      (nr) => nr.postId === payload.data.postId
    );
    if (nestedReplyIndex !== -1) {
      payload.data.target = payload.postId;
      reply.replies[nestedReplyIndex] = payload.data;

      const replyIndex = parentPost.replies.findIndex(
        (r) => r.postId === payload.postId
      );
      parentPost.replies[replyIndex] = reply;

      feed.splice(parentPostIndex, 1, parentPost);
    }
  },
  UPDATE_NESTED_REPLY_AFTER_EDIT: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.postId);
    if (!post || !post.replies) return;

    const replyIndex = post.replies.findIndex(
      (e) => e.postId === payload.replyId
    );
    if (replyIndex === -1 || !post.replies[replyIndex].replies) return;

    const nestedReplies = post.replies[replyIndex].replies;
    const nestedReplyIndex = nestedReplies.findIndex(
      (e) => e.postId === payload.nestedReplyId
    );
    if (nestedReplyIndex === -1) return;

    const nestedReply = nestedReplies[nestedReplyIndex];

    if (nestedReply?.replyCount)
      payload.data.replyCount = nestedReply.replyCount;
    if (nestedReply?.replies) payload.data.replies = nestedReply.replies;

    nestedReplies.splice(nestedReplyIndex, 1, payload.data);
  },
  INCREMENT_REPLY_REPLY_COUNT: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.postId);
    if (!post || !post.replies) return;

    const index = post.replies.findIndex((e) => e.postId === payload.replyId);
    if (index === -1) return;

    post.replies[index].replyCount++;
  },
  UPDATE_POST_LIKE: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.postId);
    if (!post) return;

    post.isLiked = payload.isLiked;
    post.likeCount = payload.likeCount;
  },
  UPDATE_POST_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.feed) return;

    const postToUpdate = state.feed.find((p) => p.postId === payload.postId);

    if (!postToUpdate) return;

    const newLikedState = !payload.isLiked;

    postToUpdate.isLiked = newLikedState;

    postToUpdate.likeCount = newLikedState
      ? (postToUpdate.likeCount += 1)
      : (postToUpdate.likeCount -= 1);
  },
  ROLLBACK_POST_LIKE: (state, payload) => {
    if (!state.feed) return;

    const postToUpdate = state.feed.find((p) => p.postId === payload.postId);

    if (!postToUpdate) return;

    postToUpdate.isLiked = payload.isLiked;
    postToUpdate.likeCount = payload.likeCount;
  },
  UPDATE_POST_FAVORITE: (state, payload) => {
    if (state.feed) {
      const post = state.feed.find((e) => e.postId === payload.postId);

      if (post) {
        post.isFavorited = payload.isFavorited;
      }
    }
  },
  /// Nested Replies
  SET_NESTED_REPLIES: (state, payload) => {
    let feedKey;
    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }
    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.postId);
    if (!post || !post.replies) return;

    const reply = post.replies.find((e) => e.postId === payload.replyId);
    if (!reply) return;

    reply.replies = payload.replies;
  },

  APPEND_NESTED_REPLY_BOTTOM: (state, payload) => {
    let feedKey;
    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }
    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.postId);
    if (!post || !post.replies) return;

    const reply = post.replies.find((e) => e.postId === payload.replyId);
    if (!reply) return;

    reply.replies = [...(reply.replies || []), ...payload.replies];
  },

  APPEND_NESTED_REPLY_TOP: (state, payload) => {
    let feedKey;
    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }
    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.postId);
    if (!post || !post.replies) return;

    const reply = post.replies.find((e) => e.postId === payload.data.target);
    if (!reply) return;

    reply.replies = reply.replies
      ? [payload.data, ...reply.replies]
      : [payload.data];
  },

  UPDATE_NESTED_REPLY: (state, payload) => {
    let feedKey;
    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }
    if (!feedKey) return;

    const feed = state[feedKey];
    const post = feed.find((e) => e.postId === payload.postId);
    if (!post || !post.replies) return;

    const reply = post.replies.find((e) => e.postId === payload.data.target);
    if (!reply || !reply.replies) return;

    const index = reply.replies.findIndex(
      (e) => e.postId === payload.data.postId
    );
    if (index === -1) return;

    const res = [...reply.replies];
    res[index] = payload.data;
    reply.replies = res;
  },

  UPDATE_NESTED_REPLY_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.feed) return;

    const post = state.feed.find((p) => p.postId === payload.postId);

    if (!post) return;

    const reply = post.replies.find((r) => r.postId === payload.replyId);

    if (!reply) return;

    const nestedReplyToUpdate = reply.replies.find(
      (nr) => nr.postId === payload.nestedReplyId
    );

    if (!nestedReplyToUpdate) return;

    const newLikedState = !payload.isLiked;

    nestedReplyToUpdate.isLiked = newLikedState;

    nestedReplyToUpdate.likeCount = newLikedState
      ? (nestedReplyToUpdate.likeCount += 1)
      : (nestedReplyToUpdate.likeCount -= 1);
  },
  ROLLBACK_NESTED_REPLY_LIKE: (state, payload) => {
    if (!state.feed) return;

    const post = state.feed.find((p) => p.postId === payload.postId);

    if (!post) return;

    const reply = post.replies.find((r) => r.postId === payload.replyId);

    if (!reply) return;

    const nestedReplyToUpdate = reply.replies.find(
      (nr) => nr.postId === payload.nestedReplyId
    );

    if (!nestedReplyToUpdate) return;

    nestedReplyToUpdate.isLiked = payload.isLiked;
    nestedReplyToUpdate.likeCount = payload.likeCount;
  },
  INCREMENT_NESTED_REPLY_REPLY_COUNT: (state, payload) => {
    let feedKey;

    if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.POSTS &&
      state.postFeed
    ) {
      feedKey = 'postFeed';
    } else if (
      state.activeFeedTab.key === PROFILE_FEED_TAB_KEYS.REPLIES &&
      state.repliesFeed
    ) {
      feedKey = 'repliesFeed';
    } else if (state.feed) {
      feedKey = 'feed';
    }

    if (!feedKey) return;

    const feed = state[feedKey];
    // Finding the post
    const post = feed.find((e) => e.postId === payload.postId);
    if (!post || !post.replies) return;

    const reply = post.replies.find((e) => e.postId === payload.replyId);
    if (!reply || !reply.replies) return;

    const nestedReply = reply.replies.find(
      (e) => e.postId === payload.nestedReplyId
    );
    if (!nestedReply) return;

    nestedReply.replyCount++;
  },
  DELETE_PROFILE_INIT: (state) => {
    state.deleteProfile = { data: null, loading: true, error: null };
  },
  DELETE_PROFILE_SUCCESS: (state) => {
    state.deleteProfile = { data: true, loading: false, error: null };
  },
  DELETE_PROFILE_ERROR: (state, err) => {
    state.deleteProfile = { data: null, loading: false, error: err };
  },
  ...MutationsCreator([
    {
      name: 'CREATE_PROFILE',
      state: 'createProfile',
    },
  ]),
};
